import axios from "axios";
import { createContext, useContext, useState } from "react";
import jwtDecode from "jwt-decode";
import { getToken } from "../../services/security";
import { BASEURL } from "../../services/url";

const AuthContext = createContext(null);
export const AuthProvider = ({ children }) => {
  const [authenticated, setAuthenticated] = useState(false);
  const login = async (body) => {
    try {
      const result = await asyncLogin(body);

      if (result && result.status === 200) {
        user(result.data);
        localStorage.setItem("token", result.data);
        setAuthenticated(true);
      }
      else {
        setAuthenticated(false);
      }
      return result;
    } catch (error) {
      throw error;
    }
  };
  const asyncLogin = async (body) => {
    return await axios
      .post(`${BASEURL}/Security/Login`, body)
      .then((d) => d);
  };
  const user = (token) => {
    if (token) {
      const jwtDecodeToken = jwtDecode(token);
      const userAux = jwtDecodeToken;
      if (userAux) {
        return userAux;
      }
    } else {
      return null;
    }
  };
  const validate = async () => {
    try {
      const result = await asyncValidate();
      if (result && result.status === 200) {
        setAuthenticated(true);
        return true;
      }
    } catch (error) {
      if (error.status === 401) {
        return false;
      }
    }
  };
  const asyncValidate = async () => {

    let token = getToken();
    return await fetch(`${BASEURL}/Security/ValidateToken`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(token),
    }).then((d) => d);
  };
  return (
    <AuthContext.Provider
      value={{ authenticated, setAuthenticated, login, user, validate }}
    >
      {children}
    </AuthContext.Provider>
  );
};
export const useAuth = () => useContext(AuthContext);
